export enum AllOrNone {
    YES = 'YES',
    NO = 'NO'
}
